import React, { useEffect, useState, useCallback } from "react";
import axiosInstance from "../api/axiosInstance";

const AddEditDesignationMaster = ({ editData, onClose, onSuccess }) => {
  const [designationName, setDesignationName] = useState("");
  const [loading, setLoading] = useState(false);

  /* ===== GET USER DATA FROM LOCALSTORAGE ===== */
  const user = JSON.parse(localStorage.getItem("user"));
  const groupId = user?.groupId;
  const userId = user?.userId || 1;

  /* ================= TITLE CASE FUNCTION ================= */
  const toTitleCase = (text) => {
    return text
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .replace(/\s+/g, " ")
      .trim();
  };

  /* ================= LOAD EDIT DATA ================= */
  useEffect(() => {
    if (editData) {
      setDesignationName(editData.designationName || "");
    }
  }, [editData]);

  /* ================= SUBMIT ================= */
  const handleSubmit = useCallback(async () => {
    const formattedName = toTitleCase(designationName);

    if (!formattedName) {
      alert("Enter designation name");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        designationId: editData?.designationId || 0,
        groupId: Number(groupId),
        designationName: formattedName,
        userId: userId,
      };

      await axiosInstance.post(
        "/DesignationMaster/UpsertDesignation",
        payload
      );

      onSuccess?.();
      onClose?.();
    } catch (err) {
      console.error("Save error:", err);
      alert("Error saving designation");
    } finally {
      setLoading(false);
    }
  }, [designationName, editData, groupId, userId, onClose, onSuccess]);

  /* ================= KEYBOARD HANDLER ================= */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }

      if (e.key === "Enter") {
        e.preventDefault();
        handleSubmit();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleSubmit, onClose]);

  /* ================= INPUT CHANGE ================= */
  const handleChange = (e) => {
    let value = e.target.value;

    value = value.replace(/\s{2,}/g, " ");

    setDesignationName(value);
  };

  /* ================= ON BLUR AUTO FORMAT ================= */
  const handleBlur = () => {
    setDesignationName((prev) => toTitleCase(prev));
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl w-[400px] p-4">
        <h3 className="text-lg font-semibold mb-3">
          {editData ? "Edit Designation" : "Add Designation"}
        </h3>

        <input
          type="text"
          value={designationName}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Enter designation"
          autoFocus
          className="w-full border px-3 py-2 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500 outline-none"
        />

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-2 border rounded-lg"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditDesignationMaster;